/* Suggested path: frontend/src/components/StampBadge.jsx
   -----------------------------------------------------------------
   Extracted from Sales & Negotiation's landing page (where it lived as a
   page-local component) so a third caller (Precision Storytelling, round
   10) doesn't become a third hand-copied variant. Sales & Negotiation's
   own skill-card config (data/configs/config.sales-negotiation.jsx) also
   hand-duplicates this same shape/typography for its "CLOSED" corner
   stamp rather than importing it — that one is left as-is, since
   reconciling it wasn't asked for here.

   `color` must be a literal hex string, not a CSS custom property —
   the fill is built by string-appending an alpha suffix to it
   (`${color}0d`), which only produces valid CSS for a hex color.
*/
const StampBadge = ({ children, color = '#6b7280', rotate = -6 }) => (
  <div style={{
    display: 'inline-flex', alignItems: 'center', gap: 6,
    padding: '4px 12px', border: `2px solid ${color}`, borderRadius: 4,
    transform: `rotate(${rotate}deg)`,
    background: `${color}0d`,
  }}>
    <span style={{
      fontSize: 10, fontWeight: 900, color, letterSpacing: '0.1em', textTransform: 'uppercase',
    }}>{children}</span>
  </div>
);

export default StampBadge;
